import styles from "./tableCells.module.scss";

export function pickStyles(pickNum: number | undefined): string | undefined {
  switch (pickNum) {
    case 1:
      return styles.gold;
    case 2:
      return styles.silver;
    case 3:
      return styles.bronze;

    default:
      return undefined;
  }
}
